module.exports = __webpack_public_path__ + "static/media/HEART-13-KING.cbb07842.svg";